export default __webpack_public_path__ + "static/media/cardboard_study_6.8c85dcbf.jpg";